// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"abcdaad6","282":"e3d877f9","290":"ea12177d","302":"17a81cf8","403":"80424ffb","543":"17a81cf8","768":"672f05dd","798":"abcdaad6","811":"0ddab239","856":"1d7deb32","901":"99e115a7"}[chunkId] + ".chunk.css";
};